import settings from 'common/configs/setting';

export default (user) => {
    const { access_token, username, api_key } = user || {};

    switch (settings.authType) {
        case 'bearer': {
            return `bearer ${access_token}`;
        }
        case 'apikey': {
            if (!username || !api_key) {
                console.error(
                    'buildAuthorization: username or api_key missing',
                    { username, api_key }
                );
                return '';
            }
            const authHeader = `ApiKey ${username}:${api_key}`;
            return authHeader;
        }
        default: {
            return '';
        }
    }
};
